import { render, staticRenderFns } from "./workFlow.vue?vue&type=template&id=849c1cec&scoped=true&"
import script from "./workFlow.vue?vue&type=script&lang=js&"
export * from "./workFlow.vue?vue&type=script&lang=js&"
import style0 from "./workFlow.vue?vue&type=style&index=0&id=849c1cec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849c1cec",
  null
  
)

export default component.exports